/* eslint-disable prettier/prettier */
import { getGiftHistApi, getUserApi, loginApi, loginSMSApi, requestOTP, updateUserInfoApi, getListInvitationApi, acceptInviteFriendApi, ShopOTPApi, buyPackageApi, addRewardApi, getSettingApi, changePassApi, updateSettingApi } from 'api/user'
import { useMutation, useQueryClient } from 'react-query'
import { saveUserInfo } from 'utils/localStorage'
import { setSocketRoomId } from 'utils/socket';

export const queryKeyUserInfo = 'userInfo'
export const queryKeySetting = 'setting'
export const queryKeyShopOTP = 'shopOTP'
export const queryKeyBuyPackage = 'buyPackage'
export const queryKeyUpdateSetting = 'updateSetting'
export const queryKeyChangePass = 'changePass'
export const queryKeAddReward = 'addReward'
export const queryKeyIsdn = 'isdn'
export const queryKeyGistHist = 'gistHist'
export const queryKeyListInvitation = 'listInvitation'
export const queryKeyAcceptInviteFriend = 'acceptInviteFriend'

export const getUserQuery = () => ({
	queryKey: [queryKeyUserInfo],
	queryFn: getUserApi,
})
export const getSettingQuery = () => ({
	queryKey: [queryKeySetting],
	queryFn: getSettingApi,
	refetchOnWindowFocus: false,

})

export const getGiftHistQuery = (time = 3, offset = 0, limit = 10) => ({
	queryKey: [queryKeyGistHist, { time, offset, limit }],
	queryFn: getGiftHistApi,
})
export const getListInvitationQuery = (offset = 0, limit = 10) => ({
	queryKey: [queryKeyListInvitation, { offset, limit }],
	queryFn: getListInvitationApi,
})

export const useLogin = (callbackSuccess = () => { }, callbackError = () => { }) => {
	const queryClient = useQueryClient()

	return useMutation(loginApi, {
		onSuccess: data => {
			saveUserInfo(data.data)
			queryClient.setQueryData(queryKeyUserInfo, data.data)
			if (data && parseInt(data.responseCode) !== 403) {
				setSocketRoomId(0);
				callbackSuccess(data.data)
			} else {
				callbackError()
			}
		},
		onSettled: async () => {
			queryClient.invalidateQueries(queryKeyUserInfo)
		},
	})
}

export const useLoginSMS = (callbackSuccess = () => { }, callbackError = () => { }) => {
	const queryClient = useQueryClient()

	return useMutation(loginSMSApi, {
		onSuccess: data => {
			saveUserInfo(data.data)
			queryClient.setQueryData(queryKeyUserInfo, data.data)
			if (data && parseInt(data.responseCode) !== 403) {
				callbackSuccess()
			} else {
				callbackError()
			}
		},
		onSettled: async () => {
			queryClient.invalidateQueries(queryKeyUserInfo)
		},
	})
}
export const useShopOTP = (callbackSuccess = () => { }, callbackError = () => { }) => {
	const queryClient = useQueryClient()

	return useMutation(ShopOTPApi, {
		onSuccess: data => {
			queryClient.setQueryData(queryKeyShopOTP, data.data)
			if (data && parseInt(data.responseCode) !== 200) {
				callbackError(data)
			} else {
				callbackSuccess(data.data)
			}
		},
		onSettled: async () => {
			queryClient.invalidateQueries(queryKeyShopOTP)
		},
	})
}
export const useBuyPackage = (callbackSuccess = () => { }, callbackError = () => { }) => {
	const queryClient = useQueryClient()

	return useMutation(buyPackageApi, {
		onSuccess: data => {
			queryClient.setQueryData(queryKeyBuyPackage, data.data)
			if (data && parseInt(data.responseCode) !== 200) {
				callbackError(data)
			} else {
				callbackSuccess(data.data)
			}
		},
		onSettled: async () => {
			queryClient.invalidateQueries(queryKeyBuyPackage)
		},
	})
}
export const useUpdateSetting = (callbackSuccess = () => { }, callbackError = () => { }) => {
	const queryClient = useQueryClient()

	return useMutation(updateSettingApi, {
		onSuccess: data => {
			queryClient.setQueryData(queryKeyUpdateSetting, data.data)
			if (data && parseInt(data.responseCode) !== 200) {
				callbackError(data)
			} else {
				callbackSuccess(data.data)
			}
		},
		onSettled: async () => {
			queryClient.invalidateQueries(queryKeyUpdateSetting)
		},
	})
}
export const useChangePass = (callbackSuccess = () => { }, callbackError = () => { }) => {
	const queryClient = useQueryClient()

	return useMutation(changePassApi, {
		onSuccess: data => {
			queryClient.setQueryData(queryKeyChangePass, data.data)
			if (data && parseInt(data.responseCode) !== 200) {
				callbackError(data)
			} else {
				callbackSuccess(data.data)
			}
		},
		onSettled: async () => {
			queryClient.invalidateQueries(queryKeyBuyPackage)
		},
	})
}
export const useAddReward = (callbackSuccess = () => { }, callbackError = () => { }) => {
	const queryClient = useQueryClient()

	return useMutation(addRewardApi, {
		onSuccess: data => {
			queryClient.setQueryData(queryKeAddReward, data.data)
			if (data && parseInt(data.responseCode) !== 200) {
				callbackError(data)
			} else {
				callbackSuccess(data.data)
			}
		},
		onSettled: async () => {
			queryClient.invalidateQueries(queryKeAddReward)
		},
	})
}

export const useRequestOTP = (callbackSuccess = () => { }, callbackError = () => { }) => {
	const queryClient = useQueryClient();

	return useMutation(requestOTP, {
		onSuccess: data => {
			queryClient.setQueryData(queryKeyIsdn, data);
			if (data && data.responseCode != 200) {
				callbackError(data)
			} else {
				callbackSuccess(data);
			}
		},
		onSettled: async () => {
			queryClient.invalidateQueries(queryKeyIsdn);
		},
	});
};

export const useUpdateUserInfo = (callbackSuccess = () => { }) => {
	const queryClient = useQueryClient();

	return useMutation(updateUserInfoApi, {
		onSuccess: data => {
			queryClient.setQueryData(queryKeyUserInfo, data);
			callbackSuccess();
		},
		onSettled: async () => {
			queryClient.invalidateQueries(queryKeyUserInfo);
		},
	});
};
export const useAcceptInviteFriend = (callbackSuccess = () => { }) => {
	const queryClient = useQueryClient();
	return useMutation(acceptInviteFriendApi, {
		onSuccess: data => {
			queryClient.setQueryData(queryKeyAcceptInviteFriend, data);
			callbackSuccess(data);
		},
		onSettled: async () => {
			queryClient.invalidateQueries(queryKeyAcceptInviteFriend);
		},
	});
};
